export default __webpack_public_path__ + "staticlp1/media/credit-card-master.4b539a20.png";